/* HUDA PORT — pink-october behaviour. Plain JS, no library (brief R5).

   COUNTDOWN. Every [data-hd-po-countdown] carries its own end instant as an ISO
   string from its section's setting. Live: [data-hd-po-live] shows and the four
   [data-cd] cells tick once a second. Ended: the timer is hidden and the
   section's [data-hd-po-ended] line (if it has one) is shown. An end value that
   does not parse hides both, rather than counting toward NaN.

   SLIDES. The home banner fades between [data-hd-po-slide] images every 5s and
   the [data-hd-po-dot] buttons jump to one. Autoplay is skipped under
   prefers-reduced-motion; the dots still work.

   Safe to load more than once on a page: each root is marked when bound. */
(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function bindCountdown(root) {
    if (root.hasAttribute('data-hd-po-bound')) return;
    root.setAttribute('data-hd-po-bound', '');
    var end = Date.parse(root.getAttribute('data-end') || '');
    var live = root.querySelector('[data-hd-po-live]');
    var ended = root.querySelector('[data-hd-po-ended]');
    var cells = root.querySelectorAll('[data-cd]');
    var timer = null;

    function show(el, on) {
      if (el) el.hidden = !on;
    }

    function tick() {
      if (isNaN(end)) {
        show(live, false);
        show(ended, false);
        return;
      }
      var now = Date.now();
      var left = Math.max(0, Math.floor((end - now) / 1000));
      var d = Math.floor(left / 86400);
      left -= d * 86400;
      var h = Math.floor(left / 3600);
      left -= h * 3600;
      var m = Math.floor(left / 60);
      var v = { d: pad(d), h: pad(h), m: pad(m), s: pad(left - m * 60) };
      cells.forEach(function (el) {
        el.textContent = v[el.getAttribute('data-cd')];
      });
      var running = end > now;
      show(live, running);
      show(ended, !running);
      if (!running && timer) clearInterval(timer);
    }

    tick();
    timer = setInterval(tick, 1000);
  }

  function bindSlides(root) {
    if (root.hasAttribute('data-hd-po-bound')) return;
    root.setAttribute('data-hd-po-bound', '');
    var slides = root.querySelectorAll('[data-hd-po-slide]');
    var dots = root.querySelectorAll('[data-hd-po-dot]');
    if (slides.length < 2) return;
    var i = 0;
    var timer = null;
    var reduce = false;
    try {
      reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {}

    function go(n) {
      i = n;
      slides.forEach(function (el, k) {
        el.classList.toggle('is-active', k === n);
      });
      dots.forEach(function (el, k) {
        el.setAttribute('aria-current', k === n ? 'true' : 'false');
      });
    }

    function start() {
      if (reduce) return;
      clearInterval(timer);
      timer = setInterval(function () {
        go((i + 1) % slides.length);
      }, 5000);
    }

    dots.forEach(function (el, k) {
      el.addEventListener('click', function () {
        go(k);
        start();
      });
    });
    start();
  }

  function init(scope) {
    var s = scope || document;
    s.querySelectorAll('[data-hd-po-countdown]').forEach(bindCountdown);
    s.querySelectorAll('[data-hd-po-slides]').forEach(bindSlides);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
